import { Feature } from '@/pinia/feature'

export const usage: Feature = {
  name: 'usage',
  enabled: true,
  access: ['FEAT_UTILIZATION_READER'],
  title: {
    en: 'Utilization and booking',
    sv: 'Användning och bokning'
  },
  component: 'DashboardFeatureUsage',
  isRoute: true,
  props: {
    icon: 'IconCalendarCheck',
    defaultFilters: {
      calendar: {
        quickSelect: 'last30days'
      },
      onlyBusinessHours: true,
      onlyBusinessDays: true,
      onlyBookable: false,
      roomTypes: [
        {
          roomGroup: 'Hörsalar'
        },
        {
          roomGroup: 'Studierum'
        },
        {
          roomGroup: 'Lärosalar'
        }
      ]
    }
  },
  children: [
    {
      name: 'kpis',
      enabled: true,
      title: {
        en: 'KPIs',
        sv: 'KPIer'
      },
      component: 'KPISection',
      isRoute: true,
      children: [
        {
          name: 'colorlegend',
          enabled: true,
          title: {
            en: 'Utilization and booking',
            sv: 'Användning och bokning'
          },
          props: {
            width: 300,
            height: 64,
            type: 'continuous'
          }
        }
      ]
    },
    {
      name: 'graphs',
      enabled: true,
      title: {
        en: 'Graphs',
        sv: 'Grafer'
      },
      component: 'GraphSection',
      isRoute: true
    },
    {
      name: 'heatmaps',
      enabled: true,
      title: {
        en: 'Heatmaps',
        sv: 'Värmekartor'
      },
      component: 'HeatmapSection',
      isRoute: true
    }
  ]
}
